import { useState } from "react";
import { FcInfo } from "react-icons/fc";
import Modal from "react-modal";
import Tooltip from "../Tooltip";
import { ResponsiveRadar } from "@nivo/radar";

Modal.setAppElement("#root");

const customStyles = {
	overlay: {
		backgroundColor: "rgba(0, 0, 0, 0)", // fully transparent; change to rgba(0,0,0,0.5) for dim without blur
	},
	content: {
		top: "52%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",
		zIndex: 1000,
		borderRadius: "10px",

		width: "100%", // Adjust modal width for responsiveness
		maxWidth: "900px", // Max width for larger screens
		maxHeight: "85vh", // Limit height for smaller screens
	},
};
const renderSkillSection = (jobSkills: any, candidateSkills: any) => {
	return (
		<div className="mb-4 px-2">
			{candidateSkills.map((categoryData: any, index: number) => {
				const jobCategory = jobSkills.find(
					(j: any) => j.category === categoryData.category
				);
				if (!jobCategory) return null;

				return (
					<div key={index} className="mb-3">
						<div className="text-lg font-medium text-[#666666] my-3 flex items-center gap-3">
							{categoryData.category}{" "}
							<span className="text-[#8183D6]">({categoryData.score}%)</span>
							<Tooltip position="bottom">
								<p className="text-justify w-[200px] md:max-w-lg overflow-auto">{categoryData.explanation || "No Explanation available"}</p>
							</Tooltip>
						</div>
						<div className="flex flex-wrap gap-2 mb-1 px-1">
							{categoryData.matched_skills.map((skill: any, i: number) => (
								<span
									key={`matched-${i}`}
									className="bg-[#D1F6D7] text-[#438437]  px-3 py-1 rounded-full mb-2"
								>
									{skill}
								</span>
							))}
						</div>
						<div className="flex flex-wrap gap-x-2 mb-1 px-1">
							{categoryData.unmatched_skills.map((skill: any, i: number) => (
								<span
									key={`unmatched-${i}`}
									className="bg-gray-200 text-gray-600 px-3 py-1 rounded-full mb-2"
								>
									{skill}
								</span>
							))}
						</div>
					</div>
				);
			})}
		</div>
	);
};

const ScoreJustificationModal = ({
	jobSkillSet,
	resumeSkill,
	overAllJustification,
}: any) => {
	const { primary_skills: jobPrimary, secondary_skills: jobSecondary } =
		jobSkillSet.skills;
	const {
		primary_skills: candidatePrimary,
		secondary_skills: candidateSecondary,
	} = resumeSkill;
	const [modalIsOpen, setIsOpen] = useState(false);

	const prepareRadarData = (primary: any[], secondary: any[]) => {
		const categories = [...primary, ...secondary];
		return categories.map((cat) => ({
			category: cat.category,
			score: cat.score || 0, // fallback to 0 if no score
		}));
	};
	const parsedList: string[] = overAllJustification
		.slice(1, -1) // Remove the enclosing {}
		.split('","') // Split by the quote-comma-quote delimiter
		.map((item: any) => item.replace(/^"|"$/g, "")); // Remove remaining quotes

	const radarData = prepareRadarData(candidatePrimary, candidateSecondary);
	const radarKeys = ["score"];


	function openModal() {
		setIsOpen(true);
	}

	function closeModal() {
		setIsOpen(false);
	}

	return (
		<div>
			<button onClick={openModal} className=" ">
				<FcInfo />
			</button>
			<Modal
				isOpen={modalIsOpen}
				onRequestClose={closeModal}
				style={customStyles}
				contentLabel="Example Modal"
			>
				<div className=" md:p-6 w-full font-heading">
					<div className="mb-4">
						<h1 className="text-2xl font-bold  ">Screening Insights </h1>{" "}


					</div>
					<div className="border mx-2 mb-4"> </div>
					<div className="text-xl font-semibold  mb-1">Summary</div>
					<ul className="list-none pl-6 space-y-1 text-gray-700 mb-5">
						{parsedList.map((point, index) => (
							<li key={index}>{point}</li>
						))}
					</ul>
					<div className="text-xl font-semibold  mb-1">Candidate Strengths and Weaknesses</div>
					<div className="h-[300px] w-full md:h-[400px] mb-6">
						<ResponsiveRadar
							data={radarData}
							keys={radarKeys}
							indexBy="category"
							valueFormat=">-.2f"
							margin={{ top: 50, right: 80, bottom: 40, left: 80 }}
							borderColor={{ from: "color" }}
							gridLevels={5}
							gridShape="circular"
							gridLabelOffset={24}
							enableDots={true}
							dotSize={10}
							dotColor={{ theme: "background" }}
							dotBorderWidth={2}
							dotBorderColor={{ from: "color" }}
							colors={{ scheme: "nivo" }}
							fillOpacity={0.25}
							blendMode="multiply"
							animate={true}
							isInteractive={true}
							theme={{
								axis: {
									legend: {
										text: {
											fontSize: 16, // Increase axis legend font size if used
										},
									},
									ticks: {
										text: {
											fontSize: 16, // Increase tick label font size
										},
									},
								},

							}}
						/>

					</div>


					<div className="mb-6">
						<h2 className="text-xl font-bold  mb-1">
							Must Have Skills	{" "}
							<span className="text-[#FFC452]">
								(Score: {resumeSkill.average_primary_score}%)
							</span>
						</h2>
						{renderSkillSection(jobPrimary, candidatePrimary)}
					</div>

					<div>
						<h2 className="text-xl font-semibold  mb-1">
							Good to Have Skills{" "}
							<span className="text-[#FFC452]">
								(Score: {resumeSkill.average_secondary_score}%)
							</span>
						</h2>
						{renderSkillSection(jobSecondary, candidateSecondary)}
					</div>
				</div>
				<div className="flex justify-center">

					<button
						onClick={closeModal}
						className=" text-lg border border-[#BDE4C3] text-[#438437] px-3 py-1 rounded hover:scale-110 transition"
					>
						Close
					</button>
				</div>
			</Modal>
		</div>
	);
};

export default ScoreJustificationModal;
